import { IllustrationSize } from "@/constants/UI";
import { EmptyListBaseCard } from "@/ui/layout";
import { IllustrationName } from "@/ui/theme/icons/illustrations/groupClasses";

const EmptyWeightDataCard = ({ testID }: ViewWithTestID) => {
  return (
    <EmptyListBaseCard
      description={
        "Once a weight value has been logged,\nyou'll be able to see history and trends here."
      }
      iconHeight={IllustrationSize.Weight}
      iconName={IllustrationName.Exclamation}
      iconWidth={IllustrationSize.Weight}
      testID={testID}
      title="No weight has been collected"
    />
  );
};

export default EmptyWeightDataCard;
